export const goAuth = () => {
  // location.href = `/online-console/commonview?backurl=${encodeURIComponent(
  //   location.href
  // )}`;
  location.href = `/cloud-console/account/identity-auth`
};
// 跳转企业员工认证
export const goStaffAuth = () => {
  // location.href = `/online-console/commonview?backurl=${encodeURIComponent(
  //   location.href
  // )}`;
  location.href = `/cloud-console/account/staff-auth`
};



// WEBPACK FOOTER //
// ./src/gtn/utils/toUplus.js